import { render } from "./CompanyInformation.vue?vue&type=template&id=90899752&scoped=true"
import script from "./CompanyInformation.vue?vue&type=script&lang=js"
export * from "./CompanyInformation.vue?vue&type=script&lang=js"

import "./CompanyInformation.vue?vue&type=style&index=0&id=90899752&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90899752"]])

export default __exports__